import React from 'react';
import { colors } from 'shared/styles';
import styled from 'styled-components';
import type { RewardV2 } from 'src/gql/graphql';

type RewardsProps = {
  rewards: Array<RewardV2>;
};

export const DposMyRewardsList = ({ rewards = [] }: RewardsProps): JSX.Element => {
  const availableRewards = rewards.filter(({ available }) => available);

  return (
    <RewardsList>
      {availableRewards.length > 0 ? (
        availableRewards.map(({ copy, costV2, id, isEligible }) => {
          const isEligibleForReward = isEligible !== false;
          return (
            isEligibleForReward && (
              <Reward key={id}>
                <Description>{copy}</Description>
                <Cost>({costV2} pts)</Cost>
              </Reward>
            )
          );
        })
      ) : (
        <NoRewardsAvailable>No eligible rewards at this time</NoRewardsAvailable>
      )}
    </RewardsList>
  );
};

const RewardsList = styled.dl`
  list-style: none;
  margin-top: 0;
`;

const Reward = styled.div`
  margin-top: 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.blueGrey[90]};
  display: flex;
  gap: 8px;
  padding: 10px 0;
`;

const Description = styled.dt`
  font-weight: bold;
`;

const Cost = styled.dd`
  color: ${colors.blueGrey};
  margin: 0;
`;

const NoRewardsAvailable = styled.div`
  color: ${colors.blueGrey};
`;
